import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const menuItems = [
    { name: "My home", path: "/" },
    { name: "Welcome to my still images", path: "/still-image-gallery" },
    { name: "My movable pieces", path: "/movable-pieces" },
    { name: "The soul of my work", path: "/soul-of-my-work" },
    { name: "A sketch of my profile", path: "/sketch-of-my-profile" },
    { name: "Find myself", path: "/find-myself" },
  ];

  return (
    <header className="text-md text-left">
      {menuItems.map((item) => (
        <p
          key={item.name}
          onClick={()=>{
            navigate(item.path);
          }}
          className={`${
            location.pathname === item.path ? "text-blue-600" : "text-gray-600"
          } hover:text-blue-600 text-sm cursor-pointer transition-colors duration-300`}
        >
          {item.name}
        </p>
      ))}
    </header>
  );
};

export default Header;
